import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { delay } from 'rxjs/operators';
import { LANGUAGES_SUPPORTED } from 'src/app/_constants/app.constants';
import { Language, ObjectLiteral } from 'src/app/_models/user';
import { LanguageService } from 'src/app/_services/api/language/language.service';
import { LoadingService } from 'src/app/_services/ui/loading/loading.service';
import { SessionService } from 'src/app/_services/session/session.service';

@Component({
  selector: 'ua-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
})
export class LanguageSelectComponent implements OnInit, OnDestroy {

  isLoading: boolean;

  languageSubscription: Subscription;

  pageConstants: ObjectLiteral = {};

  readonly defaultLang = this.languageService.defaultLanguage;

  currentLang: Language = LANGUAGES_SUPPORTED[this.languageService.currentLanguage];

  alternateLang: Language = LANGUAGES_SUPPORTED[this.languageService.defaultLanguage];

  browserDefault: Language = LANGUAGES_SUPPORTED[this.languageService.browserLanguage];

  @Input() offset: ObjectLiteral = null;

  @Input() showModal: boolean;

  @Output() languageSelect = new EventEmitter<Language>();

  @Output() dismiss = new EventEmitter();

  constructor(
    private sessionService: SessionService,
    private languageService: LanguageService,
    private loadingService: LoadingService) {
    this.languageSubscription = this.languageService.languageChanges.subscribe(() => {
      this.pageConstants = this.languageService.constants?.commons || {};
    });
  }

  ngOnInit(): void {
    if (this.currentLang.locale == this.alternateLang.locale) {
      this.alternateLang = this.browserDefault;
    }
    this.listenToLoading();
  }

  changeLanguage(updatedLanguage: Language): void {

    this.alternateLang = this.currentLang;
    this.currentLang = updatedLanguage;
    this.languageSelect.emit(updatedLanguage);
    this.dismiss.emit();
  }

  closeModal(): void {
    this.dismiss.emit();
    !this.sessionService.isLangPreferred && this.storeLangConsent(this.currentLang.locale);
  }

  storeLangConsent(value: string): void {
    this.sessionService.storeLanguagePreferred(value);
  }

  ngOnDestroy(): void {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }

  /**
  * Listen to the loadingSub property in the LoadingService class
  */
  listenToLoading(): void {
    this.loadingService.loadingSub.pipe(delay(0)).subscribe(({ loading }) => {
      this.isLoading = loading;
    });
  }
}
